import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { actions } from '../../InventoryState'
import TableMui from 'src/components/TableMui'
import { selectSkusList } from '../../InventorySelector'
import * as S from './AddSkus.styles'
import ModalDeleteSku from '../ModalDeleteSku'
import { handleOnKeyDown } from 'src/utils/Form'

interface Props {
  skus: string
  setSkus: (value: any) => void
  errors: any
  register: any
}

export const AddSkus = ({
  skus, setSkus, errors, register,
}: Props) => {
  const skusList = useSelector(selectSkusList)
  const [openModalDeleteSku, setOpenModalDeleteSku] = useState(false)
  const [skuToDelete, setSkuToDelete] = useState()

  const dispatch = useDispatch()

  const handleInputChange = (event) => {
    setSkus(event.target.value)
  }

  const validateSkus = () => {
    const valuesArray = skus
      .split(/\s+/)
      .map((value) => value.trim())
      .filter((value) => value !== '')

    dispatch(actions.validateSkus({ skus: valuesArray }))
    setSkus('')
  }

  const clearSkus = () => {
    dispatch(actions.clearState())
  }

  const onClickDelete = (item) => {
    setSkuToDelete(item)
    setOpenModalDeleteSku(true)
  }

  const tableRows = skusList
    .filter((s, index) => skusList.findIndex((item) => item.codProduct === s.codProduct) === index)
    .map((s) => ({
      ...s,
      validSku: s.valid ? <p>SKU válido</p> : <S.InvalidSku>SKU inválido, favor verificar</S.InvalidSku>,
      deleteSku: <S.RemoveBatchButton size={20} data-testid='trash-button-test' onClick={() => onClickDelete(s.codProduct)} />,
    }))
    .sort((a, b) => {
      if (a.valid && !b.valid) {
        return 1
      } if (!a.valid && b.valid) {
        return -1
      }
      return 0
    })

  return (
    <>
      <S.CustomTextArea
        inputProps={{
          ...register('skuToInventory', { required: 'Campo obrigatório' }),
          'data-testid': 'add-skus-input-test',
        }}
        id='skuToInventory'
        name='skuToInventory'
        error={!!errors.skuToInventory}
        label='skus.to.inventory'
        helperText={errors.skuToInventory?.message}
        type='text'
        autoComplete='off'
        value={skus}
        onChange={handleInputChange}
        fullWidth
        multiline
        rows={5}
        onKeyDown={(e) => handleOnKeyDown(e, 'skuToInventory', validateSkus)}
      />
      <S.ContainerButton>
        <S.CustomButtonSku
          title='Adicionar SKUs'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={validateSkus}
          disabled={!skus}
          data-testid='add-skus-button-test'
        />
        <S.CustomButtonSku
          title='Limpar tabela de SKUs'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={clearSkus}
          disabled={skusList.length === 0}
        />
      </S.ContainerButton>
      <TableMui
        columns={[
          { id: 'idModel', label: 'ID Modelo', width: 110 },
          { id: 'codProduct', label: 'Cód. produto', width: 130 },
          { id: 'descProduct', label: 'Descrição', width: 350 },
          { id: 'validSku', label: 'Validade do SKU', width: 215 },
          { id: 'deleteSku', label: 'Deletar' },
        ]}
        emptyLabel='Nenhuma lista de SKUs para mostrar'
        rows={tableRows}
        enablePagination
        rowsPerPageLimit={10}
      />
      <ModalDeleteSku
        open={openModalDeleteSku}
        setOpen={setOpenModalDeleteSku}
        skuToDelete={skuToDelete}
        skusList={skusList}
      />
    </>
  )
}
